// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Shared styles for rule selection panel components */

/* Two-panel flex container */
.rsp-container {
  flex: 1;
  overflow: hidden;
  display: flex;
}

/* Left panel – selection list */
.rsp-left-panel {
  width: 30%;
  min-width: 200px;
  max-width: 320px;
  border-right: 1px solid #e5e5e5;
  background: #fafafa;
  overflow-y: auto;
}

/* Sticky header inside a panel */
.rsp-panel-header {
  padding: 12px 16px;
  background: #f0f0f0;
  border-bottom: 1px solid #e5e5e5;
  font-weight: 600;
  font-size: 14px;
  position: sticky;
  top: 0;
  z-index: 1;
}

/* Individual list item in the left panel.
   The border-left color is supplied via the CSS custom property
   --item-status-color so callers only need a single inline style. */
.rsp-list-item {
  padding: 12px 16px;
  cursor: pointer;
  background: white;
  border-bottom: 1px solid #e5e5e5;
  border-left: 3px solid var(--item-status-color, transparent);
}

.rsp-list-item--active {
  background: #e6f2ff;
  border-left-color: #0078d4;
}

/* Item name (font styles; color is applied inline as it is dynamic) */
.rsp-item-name {
  font-weight: 600;
  font-size: 14px;
  margin-bottom: 4px;
}

/* Item subtitle */
.rsp-item-subtitle {
  font-size: 12px;
  color: #6b7280;
}

.rsp-item-subtitle--error {
  color: #d13438;
  font-weight: 600;
}

/* Right panel */
.rsp-right-panel {
  flex: 1;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
}

/* Sticky rules header inside the right panel */
.rsp-rules-header {
  padding: 12px 16px;
  background: #fafafa;
  border-bottom: 1px solid #e5e5e5;
  font-weight: 600;
  font-size: 14px;
  position: sticky;
  top: 0;
  z-index: 2;
}

/* Footer row with Back / Cancel / Primary buttons */
.rsp-footer {
  display: flex;
  justify-content: space-between;
  padding: 16px 24px;
  border-top: 1px solid #e5e5e5;
  background: white;
}

/* Informational bar above the panel layout */
.rsp-info-bar {
  padding: 16px 24px;
  border-bottom: 1px solid #e5e5e5;
  background: #f8f9fa;
}

/* Text inside the info bar */
.rsp-info-text {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
}

/* Empty state message */
.rsp-empty-state {
  padding: 24px 16px;
  text-align: center;
  color: #6b7280;
}

/* Centered "no selection" placeholder in the right panel */
.rsp-no-selection {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  color: #6b7280;
}

/* Responsive adjustments for smaller viewports */
@media (max-height: 800px) {
  .rsp-container {
    min-height: 250px;
  }
}

@media (max-width: 600px) {
  .rsp-left-panel {
    min-width: 140px;
    width: 25%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/policies/shared/ruleSelection.css"],"names":[],"mappings":"AAAA,sDAAsD;;AAEtD,6BAA6B;AAC7B;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA,gCAAgC;AAChC;EACE,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA;;oEAEoE;AACpE;EACE,kBAAkB;EAClB,eAAe;EACf,iBAAiB;EACjB,gCAAgC;EAChC,4DAA4D;AAC9D;;AAEA;EACE,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA,sEAAsE;AACtE;EACE,gBAAgB;EAChB,eAAe;EACf,kBAAkB;AACpB;;AAEA,kBAAkB;AAClB;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;EACb,sBAAsB;AACxB;;AAEA,+CAA+C;AAC/C;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,MAAM;EACN,UAAU;AACZ;;AAEA,oDAAoD;AACpD;EACE,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,6BAA6B;EAC7B,iBAAiB;AACnB;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA,6BAA6B;AAC7B;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,cAAc;AAChB;;AAEA,iDAAiD;AACjD;EACE;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE;IACE,gBAAgB;IAChB,UAAU;EACZ;AACF","sourcesContent":["/* Shared styles for rule selection panel components */\n\n/* Two-panel flex container */\n.rsp-container {\n  flex: 1;\n  overflow: hidden;\n  display: flex;\n}\n\n/* Left panel – selection list */\n.rsp-left-panel {\n  width: 30%;\n  min-width: 200px;\n  max-width: 320px;\n  border-right: 1px solid #e5e5e5;\n  background: #fafafa;\n  overflow-y: auto;\n}\n\n/* Sticky header inside a panel */\n.rsp-panel-header {\n  padding: 12px 16px;\n  background: #f0f0f0;\n  border-bottom: 1px solid #e5e5e5;\n  font-weight: 600;\n  font-size: 14px;\n  position: sticky;\n  top: 0;\n  z-index: 1;\n}\n\n/* Individual list item in the left panel.\n   The border-left color is supplied via the CSS custom property\n   --item-status-color so callers only need a single inline style. */\n.rsp-list-item {\n  padding: 12px 16px;\n  cursor: pointer;\n  background: white;\n  border-bottom: 1px solid #e5e5e5;\n  border-left: 3px solid var(--item-status-color, transparent);\n}\n\n.rsp-list-item--active {\n  background: #e6f2ff;\n  border-left-color: #0078d4;\n}\n\n/* Item name (font styles; color is applied inline as it is dynamic) */\n.rsp-item-name {\n  font-weight: 600;\n  font-size: 14px;\n  margin-bottom: 4px;\n}\n\n/* Item subtitle */\n.rsp-item-subtitle {\n  font-size: 12px;\n  color: #6b7280;\n}\n\n.rsp-item-subtitle--error {\n  color: #d13438;\n  font-weight: 600;\n}\n\n/* Right panel */\n.rsp-right-panel {\n  flex: 1;\n  overflow-y: auto;\n  display: flex;\n  flex-direction: column;\n}\n\n/* Sticky rules header inside the right panel */\n.rsp-rules-header {\n  padding: 12px 16px;\n  background: #fafafa;\n  border-bottom: 1px solid #e5e5e5;\n  font-weight: 600;\n  font-size: 14px;\n  position: sticky;\n  top: 0;\n  z-index: 2;\n}\n\n/* Footer row with Back / Cancel / Primary buttons */\n.rsp-footer {\n  display: flex;\n  justify-content: space-between;\n  padding: 16px 24px;\n  border-top: 1px solid #e5e5e5;\n  background: white;\n}\n\n/* Informational bar above the panel layout */\n.rsp-info-bar {\n  padding: 16px 24px;\n  border-bottom: 1px solid #e5e5e5;\n  background: #f8f9fa;\n}\n\n/* Text inside the info bar */\n.rsp-info-text {\n  font-size: 14px;\n  color: #6b7280;\n  line-height: 1.5;\n}\n\n/* Empty state message */\n.rsp-empty-state {\n  padding: 24px 16px;\n  text-align: center;\n  color: #6b7280;\n}\n\n/* Centered \"no selection\" placeholder in the right panel */\n.rsp-no-selection {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  color: #6b7280;\n}\n\n/* Responsive adjustments for smaller viewports */\n@media (max-height: 800px) {\n  .rsp-container {\n    min-height: 250px;\n  }\n}\n\n@media (max-width: 600px) {\n  .rsp-left-panel {\n    min-width: 140px;\n    width: 25%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
